'use client'

import { useAtomValue } from 'jotai'
import { useEffect } from 'react'
import { useAmplitudeAnalytics } from '@/src/hooks/use-amplitude-analytics'
import { sessionIdAtom, userAtom } from '@/src/stores/user/atoms'

export const AmplitudeProvider = ({
  enabled = false,
  children,
}: {
  enabled?: boolean
  children: React.ReactNode
}) => {
  const user = useAtomValue(userAtom)
  const sessionId = useAtomValue(sessionIdAtom)
  const { ampli, isInitialized } = useAmplitudeAnalytics({ init: enabled })

  useEffect(() => {
    if (isInitialized && user) {
      const userId = user.id === 'guest' ? sessionId : user.id
      ampli?.identify(userId, {
        loggedInStatus: user.id === 'guest' ? 'guest' : 'email',
        referrer: document.referrer,
      })
    } else if (isInitialized && sessionId) {
      ampli?.identify(sessionId, {
        referrer: document.referrer,
      })
    }
  }, [isInitialized, user, sessionId, ampli])

  return children
}
